<mat-form-field class="w-100 ">
  <mat-label>{{_placeholder}}</mat-label>
  <mat-icon matPrefix (click)="changeCalendar()">
    calendar_today
  </mat-icon>
  <input
    matInput
    type="text"
    placeholder="Date"
    aria-label="Date"
    aria-describedby="basic-addon2"
    #dateRangeComponent
    [disabled]="_disabled">
</mat-form-field>